<template>
  <div v-if="visible" class="epo-home-snackbar-wrap">
    <div
      class="epo-home-snackbar"
      :class="'epo-home-snackbar--' + phaseClass"
      role="status"
    >
      <img
        class="epo-home-snackbar__icon"
        :src="iconSrc"
        width="40"
        height="40"
        alt=""
      />
      <div class="epo-home-snackbar__message">
        <div class="epo-home-snackbar__content">
          <p class="epo-home-snackbar__title">{{ titleText }}</p>
          <p class="epo-home-snackbar__body">
            <template v-if="phase === 'Notify'">
              <span>{{ notifyBodyBefore }}</span>
              <span
                v-for="(mod, idx) in excessModules"
                :key="'n-' + mod.key"
              >
                <a
                  href="#"
                  class="epo-home-snackbar__link"
                  :t_label="'EMPBE_EPO_HomeSnackbar_' + mod.key + epoTrackSuffix"
                  @click.prevent="mod.go()"
                >{{ mod.label }}</a>{{ idx < excessModules.length - 1 ? $t('lbl_EMPBE_EPO_HomeSnackbar_LinkJoin') : '' }}
              </span>
              <span>{{ $t('lbl_EMPBE_EPO_HomeSnackbar_NotifyBodyAfter') }}</span>
            </template>
            <template v-else>
              <span>{{ phase === 'Action' ? $t('lbl_EMPBE_EPO_HomeSnackbar_ActionBodyBefore', snackbarDateParams) : $t('lbl_EMPBE_EPO_HomeSnackbar_BodyBefore') }}</span>
              <span
                v-for="(mod, idx) in excessModules"
                :key="'l-' + mod.key"
              >
                <a
                  href="#"
                  class="epo-home-snackbar__link"
                  :t_label="'EMPBE_EPO_HomeSnackbar_' + mod.key + epoTrackSuffix"
                  @click.prevent="mod.go()"
                >{{ mod.label }}</a>{{ idx < excessModules.length - 1 ? $t('lbl_EMPBE_EPO_HomeSnackbar_LinkJoin') : '' }}
              </span>
              <span>{{ phase === 'Action' ? $t('lbl_EMPBE_EPO_HomeSnackbar_ActionBodyAfter', snackbarDateParams) : $t('lbl_EMPBE_EPO_HomeSnackbar_BodyAfter', snackbarDateParams) }}</span>
            </template>
          </p>
        </div>
        <button
          type="button"
          class="epo-home-snackbar__cta"
          :t_label="'EMPBE_EPO_HomeSnackbar_ContactSales' + epoTrackSuffix"
          @click="openContactSales"
        >
          {{ $t('lbl_EMPBE_EPO_Banner_ContactSales') }}
        </button>
      </div>
    </div>
    <AdListContactUs ref="epoContactUs" submit-page-url="EpoHomeSnackbarContactUs" />
  </div>
</template>

<script>
import { epoService } from '../_services/epo.service';
import { normalizeApiResponse } from '../_helpers/apiResponse';
import AdListContactUs from '../pages/advertisingInfoCenter/AdListContactUs.vue';

export default {
  name: 'EpoHomeSnackbar',
  components: { AdListContactUs },
  data() {
    return {
      loading: false,
      phase: 'None',
      notice: {
        needNotice: false,
        scheduledDate: '',
        actionDeadline: '',
        excessCount: 0,
        excessProductCount: 0,
        excessGalleryCount: 0,
        excessVideoCount: 0,
        daysRemaining: 0,
        clearedCount: 0,
        clearedProductCount: 0,
        jobClearDays: 7,
        targetProductQty: 0,
        targetRoleLimit: 0,
      },
    };
  },
  computed: {
    epoTrackSuffix() {
      const u = this.$store?.state?.authentication?.user || {};
      const companyId = u.empCompanyId || u.EmpCompanyId || 0;
      const roleUserId = u.accountUserId || u.AccountUserId || 0;
      return `_${companyId}_${roleUserId}`;
    },
    visible() {
      return (
        this.notice.needNotice
        && (this.phase === 'Reminder' || this.phase === 'Action' || this.phase === 'Notify')
      );
    },
    phaseClass() {
      if (this.phase === 'Action') return 'action';
      if (this.phase === 'Notify') return 'notify';
      return 'reminder';
    },
    iconSrc() {
      const base = process.env.BASE_URL || '/';
      if (this.phase === 'Action') return `${base}img/epo-plan-changed-action.svg`;
      if (this.phase === 'Notify') return `${base}img/epo-plan-changed-notify.svg`;
      return `${base}img/epo-plan-changed-remind.svg`;
    },
    expiryDateText() {
      const raw = this.notice.scheduledDate;
      return this.formatDate(raw);
    },
    jobClearDateText() {
      const raw = this.notice.scheduledDate;
      if (!raw) return '';
      const d = new Date(raw);
      if (Number.isNaN(d.getTime())) return '';
      d.setDate(d.getDate() + (this.notice.jobClearDays || 7));
      return this.formatDate(d);
    },
    hasStillOver() {
      return (
        this.notice.excessCount > 0
        || this.notice.excessProductCount > 0
      );
    },
    hasClearedUsers() {
      return this.notice.clearedCount > 0;
    },
    hasClearedProducts() {
      return this.notice.clearedProductCount > 0;
    },
    /** Notify：仍超额用「待处理」文案；仅已清除才说「已删除/下架」 */
    notifyIsStillOver() {
      return this.phase === 'Notify' && this.hasStillOver;
    },
    deadlineDateText() {
      if (this.notice.actionDeadline) return this.formatDate(this.notice.actionDeadline);
      const raw = this.notice.scheduledDate;
      if (!raw) return '';
      const d = new Date(raw);
      if (Number.isNaN(d.getTime())) return '';
      d.setDate(d.getDate() + 6);
      return this.formatDate(d);
    },
    snackbarDateParams() {
      return {
        date: this.expiryDateText,
        deadline: this.deadlineDateText,
        autoDate: this.jobClearDateText,
      };
    },
    notifyBodyBefore() {
      if (this.notifyIsStillOver) {
        return this.$t('lbl_EMPBE_EPO_HomeSnackbar_NotifyStillOverBodyBefore', this.snackbarDateParams);
      }
      return this.$t('lbl_EMPBE_EPO_HomeSnackbar_NotifyBodyBefore', this.snackbarDateParams);
    },
    excessModules() {
      const mods = [];
      /* Reminder/Action：只链仍超额模块；Notify：仍超额或 Job 已清的也可点进去看 */
      const includeCleared = this.phase === 'Notify';
      if (this.notice.excessProductCount > 0 || (includeCleared && this.notice.clearedProductCount > 0)) {
        mods.push({
          key: 'Products',
          label: this.$t('lbl_EMPBE_EPO_HomeSnackbar_LinkProducts'),
          go: () => this.goProducts(),
        });
      }
      if (this.notice.excessCount > 0 || (includeCleared && this.notice.clearedCount > 0)) {
        mods.push({
          key: 'Users',
          label: this.$t('lbl_EMPBE_EPO_HomeSnackbar_LinkUsers'),
          go: () => this.goUsers(),
        });
      }
      return mods;
    },
    excessSummaryText() {
      if (this.phase !== 'Reminder' && this.phase !== 'Action') return '';
      const parts = [];
      if (this.notice.excessProductCount > 0) {
        parts.push(this.$t('lbl_EMPBE_EPO_HomeSnackbar_ExcessProducts', {
          count: this.notice.excessProductCount,
        }));
      }
      if (this.notice.excessCount > 0) {
        parts.push(this.$t('lbl_EMPBE_EPO_HomeSnackbar_ExcessUsers', {
          count: this.notice.excessCount,
        }));
      }
      if (!parts.length) return '';
      const verb = this.phase === 'Action'
        ? this.$t('lbl_EMPBE_EPO_HomeSnackbar_ExcessNeedHandle')
        : this.$t('lbl_EMPBE_EPO_HomeSnackbar_ExcessWillReduce');
      return `${verb}${parts.join(this.$t('lbl_EMPBE_EPO_HomeSnackbar_ExcessJoin'))}.`;
    },
    titleText() {
      if (this.phase === 'Action') {
        return this.$t('lbl_EMPBE_EPO_HomeSnackbar_ActionTitleGeneric', this.snackbarDateParams);
      }
      if (this.phase === 'Notify') {
        if (this.notifyIsStillOver) {
          return this.$t('lbl_EMPBE_EPO_HomeSnackbar_NotifyStillOverTitle', this.snackbarDateParams);
        }
        /* 仅用户被清、无产品事项 → 用户专用文案；否则用通用「部分内容已被删除或下架」 */
        if (
          this.hasClearedUsers
          && !this.hasClearedProducts
          && this.notice.excessProductCount <= 0
        ) {
          return this.$t('lbl_EMPBE_EPO_HomeSnackbar_NotifyTitle', {
            count: this.notice.clearedCount,
            ...this.snackbarDateParams,
          });
        }
        return this.$t('lbl_EMPBE_EPO_HomeSnackbar_NotifyTitleGeneric', this.snackbarDateParams);
      }
      return this.$t('lbl_EMPBE_EPO_HomeSnackbar_ReminderTitle', this.snackbarDateParams);
    },
  },
  mounted() {
    this.loadNotice();
  },
  methods: {
    toQty(v) {
      const n = Number(v);
      return Number.isFinite(n) ? n : 0;
    },
    formatDate(raw) {
      if (!raw) return '';
      const d = raw instanceof Date ? raw : new Date(raw);
      if (Number.isNaN(d.getTime())) return String(raw);
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      return `${yyyy}-${mm}-${dd}`;
    },
    canShow() {
      const user = this.$store?.state?.authentication?.user;
      if (!user) return false;
      if (String(user.userType || '').toUpperCase() === 'ADMIN') return false;
      return true;
    },
    async loadNotice() {
      if (!this.canShow() || this.loading) return;
      this.loading = true;
      try {
        const rawRes = await epoService.GetRoleInactiveNotice();
        const res = normalizeApiResponse(rawRes);
        if (!res.isSuccessful) return;
        const row = Array.isArray(res.data) ? res.data[0] : res.data;
        if (!row) return;
        const needNotice = !!(row.needNotice ?? row.NeedNotice);
        const phase = String(row.phase ?? row.Phase ?? 'None');
        this.phase = phase;
        this.notice = {
          needNotice,
          scheduledDate: row.scheduledDate ?? row.ScheduledDate ?? '',
          actionDeadline: row.actionDeadline ?? row.ActionDeadline ?? '',
          excessCount: this.toQty(row.excessCount ?? row.ExcessCount),
          excessProductCount: this.toQty(row.excessProductCount ?? row.ExcessProductCount),
          excessGalleryCount: this.toQty(row.excessGalleryCount ?? row.ExcessGalleryCount),
          excessVideoCount: this.toQty(row.excessVideoCount ?? row.ExcessVideoCount),
          daysRemaining: this.toQty(row.daysRemaining ?? row.DaysRemaining),
          clearedCount: this.toQty(row.clearedCount ?? row.ClearedCount),
          clearedProductCount: this.toQty(row.clearedProductCount ?? row.ClearedProductCount),
          jobClearDays: this.toQty(row.jobClearDays ?? row.JobClearDays) || 7,
          targetProductQty: this.toQty(row.targetProductQty ?? row.TargetProductQty),
          targetRoleLimit: this.toQty(row.targetRoleLimit ?? row.TargetRoleLimit),
        };
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('[EPO HomeSnackbar] load failed', e);
      } finally {
        this.loading = false;
      }
    },
    goProducts() {
      this.$router.push('/productInfoCenter/default');
    },
    goUsers() {
      this.$router.push('/UserSetting/MyUsers');
    },
    openContactSales() {
      const cu = this.$refs.epoContactUs;
      if (cu && typeof cu.open === 'function') {
        cu.open();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.epo-home-snackbar-wrap {
  width: 100%;
  margin-bottom: 16px;
}

.epo-home-snackbar {
  width: 100%;
  box-sizing: border-box;
  border-radius: 12px;
  border: 1px solid;
  padding: 16px;
  display: flex;
  gap: 8px;
  align-items: flex-start;

  &--reminder {
    background: #fffce5;
    border-color: #e98024;
  }

  &--action {
    background: #fcebed;
    border-color: #cd1515;
  }

  &--notify {
    background: #e7f8ff;
    border-color: #2c6ecb;
  }
}

.epo-home-snackbar__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: block;
}

.epo-home-snackbar__message {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.epo-home-snackbar__content {
  flex: 1 1 268px;
  max-width: 70%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.epo-home-snackbar__title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.8);
}

.epo-home-snackbar__body {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.8);
}

.epo-home-snackbar__excess {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.75);
}

.epo-home-snackbar__link {
  color: #7366ff;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    color: #4433ff;
    text-decoration: none;
  }
}

.epo-home-snackbar__cta {
  flex-shrink: 0;
  margin: 0;
  padding: 8px 12px;
  border: 1px solid #7968ff;
  border-radius: 4px;
  background: transparent;
  color: #7366ff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: -0.154px;
  cursor: pointer;

  &:hover {
    background: #4433ff;
    border-color: #4433ff;
    color: #fff;
  }
}
</style>
